"use strict";
// packages/types/src/api/employee.ts
Object.defineProperty(exports, "__esModule", { value: true });
